import PropTypes from "prop-types";
import React from "react";
import { Navigate } from "react-router-dom";

import LottieSpinner from "./LottieSpinner";

const PrivateRoute = ({ element, user, loadingUser, requiredRoles = [] }) => {
    if(loadingUser) {
        return <LottieSpinner />;
    }

    // Unauthenticated
    if(!user?.id) {
        return <Navigate to="/unauthorized?auto=1" replace />;
    }

    // Unauthorized role
    if(requiredRoles.length && !requiredRoles.includes(user.role)) {
        return <Navigate to="/access-denied" replace />;
    }

    // Unverified profile (IMPORTANT) - but exclude admins from this check
    // Also allow investors and entrepreneurs who have submitted their applications
    if(
        user.role !== "user" &&
        user.role !== "admin" &&
        String(user.isProfileVerified) !== "true"
    ) {
        // Allow investors who have submitted their application
        if(user.role === "investor" && user.application_submitted === 1) {
            return element;
        }
        // Allow entrepreneurs who have submitted their application
        if(user.role === "entrepreneur" && user.application_submitted === 1) {
            return element;
        }
        return <Navigate to="/unauthorized?auto=1" replace />;
    }

    return element;
};

PrivateRoute.propTypes = {
    element: PropTypes.node.isRequired,
    user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        role: PropTypes.string,
        isProfileVerified: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string,
        ]),
        application_submitted: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.number,
        ]),
    }),
    loadingUser: PropTypes.bool,
    requiredRoles: PropTypes.arrayOf(PropTypes.string),
};

export default PrivateRoute;
